// extracted by mini-css-extract-plugin
export default {"item":"MapKeywordItem_item__8bc2q"};